import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        phone: '',
        email: '',
        message: ''
      });
    }, 2000);
  };

  return (
    <section className="contact-section">
      <div className="container">
        <h2>CONTACT US</h2>
        <div className="contact-divider"></div>
        
        <div className="contact-info">
          <div className="contact-details">
            <p><strong>Office:</strong></p>
            <p>+19033531539</p>
            <p>905 US Highway 79 N</p>
            <p>Henderson, TX 75652-6111</p>
           
            <p><strong>Sales Inquiries:</strong></p>
            <p><strong>support@cluservicesco.com</strong></p>
            <p><strong>Services:</strong> Utility Installation & General Contracting</p>
            <p><strong>Service Area:</strong> Carmel, CA & Surrounding Areas</p>
          </div>
        </div>
        
        <div className="contact-form">
          <h3>Request a Quote</h3>
          <p>Get a free estimate for your utility installation or contracting project</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Name"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                rows="5"
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
          
          {submitStatus === 'success' && (
            <div className="success-message">
              <p>Thank you for contacting us.</p>
              <p>We will get back to you as soon as possible</p>
            </div>
          )}
          
          {submitStatus === 'error' && (
            <div className="error-message">
              <p>Oops, there was an error sending your message.</p>
              <p>Please try again later</p>
            </div>
          )}
        </div>
        
        <div className="back-to-top">
          <a href="#top">BACK TO TOP</a>
        </div>
      </div>
    </section>
  );
};

export default Contact;